import type { ReactNode } from "react";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

type ButtonLoadingContentProps = {
    loading?: boolean;
    children: ReactNode;
    spinner?: ReactNode;
    labelClassName?: string;
    spinnerClassName?: string;
    loaderId?: string;
};

export function loadingButtonClass(loading?: boolean, className?: string) {
    return cn(className, loading && "gs-btn-loading relative");
}

export function ButtonLoadingContent({
    loading = false,
    children,
    spinner,
    labelClassName,
    spinnerClassName,
    loaderId,
}: ButtonLoadingContentProps) {
    return (
        <>
            <span className={cn(loading && "invisible", labelClassName)}>{children}</span>
            {loading
                ? spinner ?? (
                      <Spinner
                          id={loaderId}
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className={cn(
                              "gs-btn-loading-spinner absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-white",
                              spinnerClassName
                          )}
                      />
                  )
                : null}
        </>
    );
}
